document.addEventListener('DOMContentLoaded', function () {
  var icons = [
    "https://cdn.shopify.com/s/files/1/0320/1712/1413/files/handle_derby_120x120_4919337d-c25d-4ccb-afbc-921e4fe26ad0.jpg?v=1630515545",
    "https://cdn.shopify.com/s/files/1/0320/1712/1413/files/handle_fritz_120x120_e8c81764-0e87-4549-8650-42369fd342ab.jpg?v=1630515574",
    "https://cdn.shopify.com/s/files/1/0320/1712/1413/files/handle_knob_120x120_d97d7f8f-4efa-4f6a-917a-abe9f0685557.jpg?v=1630515588",
    "https://cdn.shopify.com/s/files/1/0320/1712/1413/files/handle_animal_120x120_4a9d67fa-9b0a-4071-bd8c-11100d122add.jpg?v=1630515554",
    "https://cdn.shopify.com/s/files/1/0320/1712/1413/files/handle_palm_grip_120x120_a9b826d5-e9f2-4293-9376-84f19e5c855b.jpg?v=1630515609",
    "https://cdn.shopify.com/s/files/1/0320/1712/1413/files/handle_offset_120x120_b2d55917-01a8-49ce-a281-045803ca7c4b.jpg?v=1630515599",
    "https://cdn.shopify.com/s/files/1/0320/1712/1413/files/handle_ergonomic_120x120_21ed48b9-722c-4a17-b31a-d88cb873cfae.jpg?v=1630515563",
    "https://cdn.shopify.com/s/files/1/0320/1712/1413/files/handle_tourist_120x120_e5d6ac12-e095-4cc4-8e14-dba447d07702.jpg?v=1630515620"
  ];

  var links = document.querySelectorAll(".menu__panel > .menu__item:nth-child(4) .menu__item--has-children.col-lg-2:nth-last-child(2) .menu__list--styled .menu__item a");
  if (!links || !links.length) return;

  var count = Math.min(links.length, icons.length);

  for (var i = 0; i < count; i++) {
    var a = links[i];
    // Skip if already decorated
    if (a.querySelector('img.menu_icon')) continue;

    var img = new Image(30, 30);
    img.src = icons[i];
    img.width = 30;
    img.height = 30;         // reserves space, avoids CLS
    img.decoding = 'async';
    img.fetchPriority = 'low';
    img.className = "menu_icon";

    // Basic alt: take link text or fallback
    var text = (a.textContent || '').trim();
    img.alt = text ? text + " icon" : "Menu icon";

    // Ensure spacing before inserting
    a.insertAdjacentElement('afterbegin', img);
  }
});